import { now } from "../firebase";

export default class Executions {
  db: firebase.firestore.Firestore;
  collection: firebase.firestore.CollectionReference;

  constructor(db: firebase.firestore.Firestore, uid: string) {
    this.db = db;
    this.collection = db
      .collection("users")
      .doc(uid)
      .collection("executions");
  }

  all(): Promise<any[]> {
    return this.collection
      .orderBy("created")
      .get()
      .then(function(querySnapshot: any) {
        let executions: any[] = [];
        querySnapshot.forEach(function(doc: any) {
          const number = executions.length + 1;
          executions.push({ id: doc.id, number: number, ...doc.data() });
        });
        return executions;
      });
  }

  create(attrs: any): Promise<any> {
    attrs = { ...attrs, created: now() };
    return this.collection
      .add(attrs)
      .then((ref: any) =>
        ref.get().then((doc: any) => ({ id: doc.id, ...doc.data() }))
      );
  }

  update(id: any, attrs: any): Promise<any> {
    return this.collection
      .doc(id)
      .set(attrs)
      .then(() => ({ id: id, ...attrs }));
  }
}
